import {
  REQUEST_QA_CASE,
  RECEIVE_QA_CASE,
  ERROR_QA_CASE,
  REQUEST_QA_CASE_INFO,
  RECEIVE_QA_CASE_INFO,
  ERROR_QA_CASE_INFO,
  REQUEST_QA_CASE_RETURN,
  RECEIVE_QA_CASE_RETURN,
  ERROR_QA_CASE_RETURN,
  REQUEST_QA_CASE_SEND,
  RECEIVE_QA_CASE_SEND,
  ERROR_QA_CASE_SEND,
  REQUEST_QA_CASE_COMPLETE,
  RECEIVE_QA_CASE_COMPLETE,
  ERROR_QA_CASE_COMPLETE,
  REQUEST_TIMELOGBYDAY_SUMMARY,
  RECEIVE_TIMELOGBYDAY_SUMMARY,
  ERROR_TIMELOGBYDAY_SUMMARY,
  SET_QA_READY,
  SET_QA_STARTED,
  SET_QA_PAUSED,
  SET_QA_VALIDATION_ERRORS,
  SET_QA_SUMMARYVIEW_ENABLED,
  SET_QA_KEEP_GETTING_CASES,
  SET_QA_SHOW_REJECT_DIALOG,
  SET_QA_SWITCH_CASE_DIALOG,
  SET_QA_SHOW_SEND_MANAGER_DIALOG,
  SET_QA_SHOW_COMPLETED_CASE_DIALOG,
  SET_QA_COMPLETING_CASE,
  SET_QA_REJECTING_CASE,
  SET_QA_ESCALATING_CASE,
  SET_QA_VIEW_SAVE_DATA,
  RESET_QA_STATE,
  SET_QA_TIMESPENT,
  REQUEST_QA_SKETCH,
  RECEIVE_QA_SKETCH,
  ERROR_QA_SKETCH,
  REQUEST_QA_RCT,
  RECEIVE_QA_RCT,
  ERROR_QA_RCT,
  REQUEST_QA_PAY_PERIOD,
  RECEIVE_QA_PAY_PERIOD,
  ERROR_QA_PAY_PERIOD,
  REQUEST_360_VALUE,
  RECEIVE_360_VALUE,
  ERROR_360_VALUE,
  REQUEST_QA_MANAGERS,
  RECEIVE_QA_MANAGERS,
  ERROR_QA_MANAGERS,
  UPDATE_QA_REDUX_CASEINFO,
  PHOENIX_RCT_NEEDS_COMMIT,
  BEGIN_UPDATE_CASE_ISSUES,
  REQ_POST_CASE_ISSUES, 
  RES_POST_CASE_ISSUES, 
  ERR_POST_CASE_ISSUES,
  REQUEST_CASE_HAZARDS,
  RECEIVE_CASE_HAZARDS,
  ERROR_CASE_HAZARDS,
  RESET_QA_CASE,
  REQUEST_QA_ASSIGNABLE_USERS,
  RECEIVE_QA_ASSIGNABLE_USERS,
  ERROR_QA_ASSIGNABLE_USERS,
  SET_QA_TIMER_INFO,
  REQUEST_E2VALUE,
  RECEIVE_E2VALUE,
  ERROR_E2VALUE,
} from "typeConstants";
import { qualityAssurance as initialState, qualityAssurance as resetState  } from "../initialState.tsx";

const resetQAVariables = {
  qaReady: false,
  qaStarted: false,
  qaPaused: false,
  validationErrors: [],
  summaryViewEnabled: false,
  canToggleSummaryView: false,
  keepGettingCases: true,
  showRejectDialog: false,
  showSwitchCaseDialog: false,
  switchCaseDialogControlNum: null,
  showSendToManagerDialog: false,
  showCompleteCaseDialog: false,
  qaViewRef: null,
  timeSpent: null
};

const qualityAssurance = (state = initialState, action) => {
  switch (action.type) {
    // Request Reducers
    case REQUEST_QA_CASE:
      return {
        ...state,

        requestSuccessful: false,
        qaCase: initialState.qaCase,
        value360: initialState.value360,
      };
    case REQUEST_QA_CASE_INFO:
      return {
        ...state,

      };
    case REQUEST_QA_CASE_RETURN:
      return {
        ...state,

      };
    case REQUEST_QA_CASE_SEND:
      return {
        ...state,

      };
    case REQUEST_QA_CASE_COMPLETE:
      return {
        ...state,

      };
    case REQUEST_QA_SKETCH:
      return {
        ...state,

      };
    case REQUEST_QA_RCT:
      return {
        ...state,
        caseRCT: {}, 
        requestingCaseRCT: true,
        hasCaseRCT: false,
      };

    // Receive Reducers
    case RECEIVE_QA_CASE:
      return {
        ...state,
        qaCase: action.payload,
        requestSuccessful: true,

        qaVariables: {
          ...state.qaVariables,
          summaryViewEnabled: action.payload.summaryViewEnabled,
          canToggleSummaryView: action.payload.summaryViewEnabled,
          subscribeToCaseEventMessages: action.payload.subscribeToCaseEventMessages,
        }
      };
    case RECEIVE_QA_CASE_INFO:
      return {
        ...state,
        qaCase: {
          ...state.qaCase,
          caseInfo: action.payload.caseInfo,
          summaryInfo: action.payload.summaryInfo
        },
        requestSuccessful: true,
      };
    case RECEIVE_QA_CASE_RETURN:
      if (action.payload.isInvalid) {
        return {
          ...state,
          requestSuccessful: false,
        };
      }
      else {
        return {
          ...state,
          requestSuccessful: true,
          controlNumber: 0
        };
      }
    case RECEIVE_QA_CASE_SEND:
      return {
        ...state,
        requestSuccessful: true,
        controlNumber: 0
      };
    case RECEIVE_QA_CASE_COMPLETE:
      return {
        ...state,
        requestSuccessful: true,
        controlNumber: 0
      };
    case RECEIVE_QA_SKETCH:
      return {
        ...state,
        requestSuccessful: true,

        qaCase: {
          ...state.qaCase,
          caseSketch: action.payload.sketch
        }
      };
    case RECEIVE_QA_RCT:
      return {
        ...state,
        requestSuccessful: true,
        caseRCT: action.payload.rctViewModel ?? {}, // returns null on cases without corelogic RCT, but state is expecting an empty object
        requestingCaseRCT: false,
        hasCaseRCT: !!action.payload.rctViewModel,
      };
   
    // Error reducers
    case ERROR_QA_CASE:
      return {
        ...state,
        requestSuccessful: false,
        // Reset QA Variables so that QA can try again to get a case
        qaVariables: {
          ...state.qaVariables,
          ...resetQAVariables
        }
      };
    case ERROR_QA_CASE_INFO:
      return {
        ...state,

        requestSuccessful: false
      };
    case ERROR_QA_CASE_RETURN:
      return {
        ...state,

        requestSuccessful: false
      };
    case ERROR_QA_CASE_SEND:
      return {
        ...state,

        requestSuccessful: false
      };
    case ERROR_QA_CASE_COMPLETE:
      return {
        ...state,

        requestSuccessful: false
      };

    ///REDUX STORE STATE SETTING REDUCERS
    case SET_QA_READY:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          qaReady: action.payload
        }
      };
    case SET_QA_STARTED:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          qaStarted: action.payload
        }
      };
    case SET_QA_PAUSED:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          qaPaused: action.payload
        }
      };
    case SET_QA_VALIDATION_ERRORS:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          validationErrors: action.payload
        }
      };
    case SET_QA_SUMMARYVIEW_ENABLED:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          summaryViewEnabled: action.payload
        }
      };
    case SET_QA_SHOW_REJECT_DIALOG:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          showRejectDialog: action.payload
        }
      };
    case SET_QA_SWITCH_CASE_DIALOG:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          showSwitchCaseDialog: action.payload.shouldShowDialog,
          switchCaseDialogControlNum: action.payload.controlNumber,
        }
      };
    case SET_QA_SHOW_SEND_MANAGER_DIALOG:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          showSendToManagerDialog: action.payload
        }
      };
    case SET_QA_SHOW_COMPLETED_CASE_DIALOG:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          showCompleteCaseDialog: action.payload
        }
      };
    case SET_QA_COMPLETING_CASE:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          completingCase: action.payload,
        }
      };
    case SET_QA_REJECTING_CASE:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          rejectingCase: action.payload,
        }
      };
    case SET_QA_ESCALATING_CASE:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          escalatingCase: action.payload,
        }
      };
    case SET_QA_KEEP_GETTING_CASES:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          keepGettingCases: action.payload
        }
      };
    case SET_QA_VIEW_SAVE_DATA:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          qaSaveDataFunction: action.payload
        }
      };
    case RESET_QA_STATE:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          ...resetQAVariables
        }
      };
    case SET_QA_TIMESPENT:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          timeSpent: action.payload
        }
      };
    case ERROR_QA_SKETCH:
      return {
        ...state,

        requestSuccessful: false
      };
    case ERROR_QA_RCT:
      return {
        ...state,
        caseRCT: {},
        hasCaseRCT: false,
        requestSuccessful: false,
        requestingCaseRCT: false,
      };
    case REQUEST_TIMELOGBYDAY_SUMMARY:
      return {
        ...state,
        isFetchingTimeLogByDaySummary: true,
      };
    case RECEIVE_TIMELOGBYDAY_SUMMARY:
      return {
        ...state,
        isFetchingTimeLogByDaySummary: false,
        timeLogByDaySummary: action.payload
      };
    case ERROR_TIMELOGBYDAY_SUMMARY:
      return {
        ...state,
        isFetchingTimeLogByDaySummary: false,
      };
    case REQUEST_QA_PAY_PERIOD:
      return {
        ...state,
        fetchingPayPeriodSummary: true
      };
    case RECEIVE_QA_PAY_PERIOD:
      return {
        ...state,
        payPeriodSummary: action.payload,
        fetchingPayPeriodSummary: false
      };
    case ERROR_QA_PAY_PERIOD:
      return {
        ...state,
        fetchingPayPeriodSummary: false
      };
    case REQUEST_QA_MANAGERS:
      return {
        ...state,
        isFetchingManagers: true
      };
    case RECEIVE_QA_MANAGERS:
      return {
        ...state,
        managers: action.payload,
        isFetchingManagers: false
      };
    case REQUEST_360_VALUE:
      return {
        ...state,
        isFetching360: true
      };
    case RECEIVE_360_VALUE:
      return {
        ...state,
        value360: action.payload,
        isFetching360: false
      };
    case ERROR_360_VALUE:
      return {
        ...state,
        isFetching360: false
      };
    case REQUEST_E2VALUE:
      return {
        ...state,
        isFetchingE2: true,
      };
    case RECEIVE_E2VALUE:
      return {
        ...state,
        hasE2Value: action.payload,
        isFetchingE2: false,
      };
    case ERROR_E2VALUE:
      return {
        ...state,
        isFetchingE2: false,
      };
    case ERROR_QA_MANAGERS:
      return {
        ...state,
        isFetchingManagers: false
      };
    case UPDATE_QA_REDUX_CASEINFO:
      return {
        ...state,
        qaCase: {
          ...state.qaCase,
          caseInfo: {
            ...state.qaCase.caseInfo,
            ...action.payload,
          },
        },
      };
    case PHOENIX_RCT_NEEDS_COMMIT:
      return {
        ...state,
        qaVariables: {
          ...state.qaVariables,
          phoenixRctNeedsCommit: action.payload,
        },
      };
    case BEGIN_UPDATE_CASE_ISSUES:
      return {
        ...state,
        updatingCaseIssues: true,
      };
    case REQ_POST_CASE_ISSUES:
      return {
        ...state,
        updatingCaseIssues: true,
      };
    case RES_POST_CASE_ISSUES:
      return {
        ...state,
        updatingCaseIssues: false,
      };
    case ERR_POST_CASE_ISSUES:
      return {
        ...state,
        updatingCaseIssues: false,
      };
    case REQUEST_CASE_HAZARDS:
      return {
        ...state,
        isFetchingCaseHazards: true,
      };
    case RECEIVE_CASE_HAZARDS:
      return {
        ...state,
        caseHazards: action.payload,
        isFetchingCaseHazards: false,
      };
    case ERROR_CASE_HAZARDS:
      return {
        ...state,
        isFetchingCaseHazards: false,
      };
    case RESET_QA_CASE:
      return {
        ...state,
        qaCase: resetState.qaCase
      };
    case REQUEST_QA_ASSIGNABLE_USERS:
      return {
        ...state,
        isFetchingAssignableUsers: true,
      };
    case RECEIVE_QA_ASSIGNABLE_USERS:
      return {
        ...state,
        assignableUsers: action.payload,
        isFetchingAssignableUsers: false,
      };
    case ERROR_QA_ASSIGNABLE_USERS:
      return {
        ...state,
        isFetchingAssignableUsers: false,
      };
    case SET_QA_TIMER_INFO:
      return {
        ...state,
        timerId: action.payload.timerId,
        timerPingIntervalSeconds: action.payload.timerPingIntervalSeconds,
      };
    default:
      return state;
  }
};

export default qualityAssurance;